module.exports = __webpack_public_path__ + "img/retrospect-inspect-large.526d3d5b.jpg";